module.exports = "https://s91588.cdn.ngenix.net/creditselection-frontend/_next/static/images/hero-323e7b832e7d641b9d0f81392b8d4c3f.png";